import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.states';
import { Observable, of } from 'rxjs';
import { loadUserPredictions } from '../store/actions/prediction.actions';
import { loadSports } from '../store/actions/sport.actions';  
import { loadCompetitions } from '../store/actions/competitions.actions';
import { loadFollowedPredictions } from '../store/actions/follow-prediction.actions';
import { loadUserCredits } from '../store/actions/credits.actions';

export const predictionGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const store = inject(Store<AppState>);
  const userId = JSON.parse(localStorage.getItem('user') || '{}').user_id  
  if ( !userId) return of(false);
  store.dispatch(loadCompetitions()); 
  store.dispatch(loadUserCredits({ userId:userId }));
  store.dispatch(loadUserPredictions({ userId:userId }));
  store.dispatch(loadSports())
  store.dispatch(loadFollowedPredictions({ userId: userId }));
  
  return of(true);
};
